import React from 'react';
import { Tabs, Tooltip, Button, Grid } from 'antd';
import { truncate } from 'lodash';
import { TabText } from '../../../../../../shared/globalStyling/styledText';

const TransactionCampaignTabs = ({ campaigns, campaignIndex, setCampaignIndex }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <Tabs
      activeKey={campaignIndex}
      tabPosition={screens.xs ? 'left' : 'top'}
      onChange={setCampaignIndex}
      destroyInactiveTabPane={true}
    >
      <Tabs.TabPane tab={<TabText text="All" />} key="All" />
      {campaigns?.map((campaign, i) => (
        <Tabs.TabPane
          key={i.toString()}
          tab={
            <Tooltip title={campaign.campaignName || `Campaign ${i + 1}`}>
              <Button
                style={{
                  background: 'transparent',
                  border: 0,
                  boxShadow: 'none',
                }}
              >
                <TabText
                  text={truncate(campaign.campaignName || `Campaign ${i + 1}`, { length: 25 })}
                />
              </Button>
            </Tooltip>
          }
        />
      ))}
    </Tabs>
  );
};

export default TransactionCampaignTabs;
